import React, { useState } from "react";
import { Button, IconButton, Tooltip } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import { toast } from "react-toastify";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import ConfirmationModal from "../ConfirmationModal";

// Cancelar un import pending / paused_meta / processing. Reusa
// POST /bulk-send/imports/:id/cancel (admin + companyId del token).
export const CANCELLABLE_STATUSES = ["pending", "paused_meta", "processing"];

const CancelImportButton = ({ importId, onCancelled, compact = false }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    setBusy(true);
    try {
      await api.post(`/bulk-send/imports/${importId}/cancel`);
      toast.success(i18n.t("bulkImport.cancelSuccess"));
      if (onCancelled) onCancelled(importId);
    } catch (e) {
      toast.error(i18n.t("bulkImport.cancelError"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      {compact ? (
        <Tooltip title={i18n.t("bulkImport.cancelButton")}>
          <span>
            <IconButton
              size="small"
              disabled={busy}
              onClick={(e) => { e.stopPropagation(); setOpen(true); }}
              aria-label={i18n.t("bulkImport.cancelButton")}
            >
              <CancelIcon fontSize="small" style={{ color: "#d32f2f" }} />
            </IconButton>
          </span>
        </Tooltip>
      ) : (
        <Button variant="outlined" startIcon={<CancelIcon />} disabled={busy} onClick={() => setOpen(true)}>
          {i18n.t("bulkImport.cancelButton")}
        </Button>
      )}
      <ConfirmationModal
        open={open}
        title={i18n.t("bulkImport.cancelConfirmTitle")}
        onClose={setOpen}
        onConfirm={handleConfirm}
      >
        {i18n.t("bulkImport.cancelConfirmBody")}
      </ConfirmationModal>
    </>
  );
};

export default CancelImportButton;
